/**
 * Allow using v-model from the outside and provide this property internal
 *
 * @property {string} name The name of the internal property
 * @returns {object} The mixin which can be used in a component
 */
export function vModel(name) {
	return {
		computed: {
			[name]: {
				get() {
					return this.$attrs.value;
				},
				set(value) {
					this.$emit('input', value);
				},
			},
		},
	};
}

/**
 * Allow using .sync from the outside and provide that property internal
 *
 * @property {string} name The name of the property
 * @returns {object} The mixin which can be used in a component
 */
export function vSync(name) {
	return {
		computed: {
			[name]: {
				get() {
					return this.$attrs[name];
				},
				set(value) {
					this.$emit(`update:${name}`, value);
				},
			},
		},
	};
}

/**
 * Allow adding a property with a default value and provide that property
 * internal.
 * Since vue 1.0.25 a default definition in the props only works for undefined.
 * This allow setting a default witch works with all falsy values.
 *
 * Can be updated with an object merge strategy if needed.
 *
 * @property {string} name The name of the property
 * @returns {object} The mixin which can be used in a component
 */
export function propsAdd(name, defaultVal) {
	return {
		computed: {
			[name]() {
				return this.$attrs[name] || defaultVal;
			},
		},
	};
}

export const renderRect = {
	data: () => ({
		renderRect: {},
	}),
	async mounted() {
		await this.$nextTick();
		const { width, height } = this.$el.getBoundingClientRect();
		this.renderRect = { width, height };

		try {
			this.$options.resizeObserver = new ResizeObserver(([el]) => {
				const { width, height } = el.contentRect;
				this.renderRect = { width, height };
			});
			this.$options.resizeObserver.observe(this.$el);
		} catch (error) {
			console.error(error);
		}
	},
	beforeDestroy() {
		try {
			this.$options.resizeObserver.disconnect();
			this.$options.resizeObserver = null;
		} catch {
			// Not relevant
		}
	},
};
